import type { Vehicle, ColourOption, Ply, VendorsApiResponse } from './types';

// ╔══════════════════════════════════════════════════════════════════════╗
// ║  API CONFIG — update before deploying                               ║
// ╚══════════════════════════════════════════════════════════════════════╝
export const API_CONFIG = {
  BASE_URL: 'https://your-internal-api.example.com',
  BEARER_TOKEN: 'YOUR_API_TOKEN_HERE',
  VENDORS_ENDPOINT: '/api/vendors',
  VENDORS_KEY: 'vendors',
} as const;

// ╔══════════════════════════════════════════════════════════════════════╗
// ║  VEHICLE CONFIG — sorted cheapest → largest                         ║
// ║  AI picks the smallest vehicle whose cargo_m3 fits the full order   ║
// ╚══════════════════════════════════════════════════════════════════════╝
export const VEHICLES: Vehicle[] = [
  { name: 'Mini truck', cargo_m3: 8, rate_per_km: 18 },
  { name: '12ft truck', cargo_m3: 20, rate_per_km: 25 },
  { name: '16ft truck', cargo_m3: 35, rate_per_km: 35 },
  { name: '20ft truck', cargo_m3: 50, rate_per_km: 45 },
];

// ╔══════════════════════════════════════════════════════════════════════╗
// ║  PRINTING CONFIG                                                     ║
// ╚══════════════════════════════════════════════════════════════════════╝
export const DEFAULT_PRINT_RATE = 1; // ₹ per kg of outer liner

export const COLOUR_OPTIONS: ColourOption[] = [
  { label: 'No print', multiplier: 0 },
  { label: '1 colour', multiplier: 1 },
  { label: '2 colours', multiplier: 2 },
  { label: 'CMYK', multiplier: 3 },
];

// ╔══════════════════════════════════════════════════════════════════════╗
// ║  PACKING EFFICIENCY — accounts for stacking gaps inside the truck   ║
// ╚══════════════════════════════════════════════════════════════════════╝
export const PACKING_EFFICIENCY = 0.85;

// ╔══════════════════════════════════════════════════════════════════════╗
// ║  MOCK MODE — set to false to call real API                          ║
// ╚══════════════════════════════════════════════════════════════════════╝
export const USE_MOCK = true;

// ─── CORRUGATED BOX DOMAIN CONSTANTS ─────────────────────────────────────────

export interface FluteInfo {
  takeup: number;
  desc: string;
}

export const FLUTE_TYPES: Record<string, FluteInfo> = {
  'A-Flute': { takeup: 1.56, desc: 'Thick, max cushioning' },
  'B-Flute': { takeup: 1.32, desc: 'Thin, good printability' },
  'C-Flute': { takeup: 1.45, desc: 'Most common, balanced' },
  'E-Flute': { takeup: 1.25, desc: 'Very thin, retail boxes' },
  'F-Flute': { takeup: 1.14, desc: 'Ultra thin, micro flute' },
};

export const PLY_MATERIALS: string[] = [
  'Kraft',
  'Test Liner',
  'Corrugating Medium',
  'Semi-Chemical',
  'Waste-Based',
];

export const defaultPlies = (): Ply[] => [
  { type: 'liner', material: 'Kraft', gsm: '', fluteType: 'C-Flute' },
  { type: 'flute', material: 'Corrugating Medium', gsm: '', fluteType: '' },
  { type: 'liner', material: 'Kraft', gsm: '', fluteType: 'C-Flute' },
];

export const formatINR = (value: number | string): string =>
  Number(value).toLocaleString('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 2,
  });
